module.exports = __webpack_public_path__ + "static/media/tooltip_ci.be614cd9.svg";